module.exports = __webpack_public_path__ + "img/teema.b3562124.jpg";